var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtendenteIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 94.96 95.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -985.86,
    y: -1595.24,
    width: 1920,
    height: 1080.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -57.43,
    y1: -3499.17,
    x2: -56.03,
    y2: -3499.17,
    gradientTransform: "matrix(781.05, 0, 0, -781.05, 44550.12, -2733284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f36279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ef4b63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ea334c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e7223c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e61832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e5152f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e21535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d81645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c81861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b41a83"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.76,73c0-1.78,0-3.41,0-5a2.51,2.51,0,0,0-.41-1.38,22.38,22.38,0,0,1-4.18-10.23c-1.55,0-3,.05-4.48,0-4.36-.18-7.67-2.76-8.49-6.64A13.78,13.78,0,0,1,11,47q0-5,0-10c0-5.09,1.86-7.61,6.69-9.25.13,0,.24-.15.19-.12.54-3,.91-6,1.62-8.82a27.9,27.9,0,0,1,2.33-6.11c3.38-6.44,9-10,15.9-11.59A40.15,40.15,0,0,1,61,2.36,22.16,22.16,0,0,1,74.92,16.77a40.78,40.78,0,0,1,1.35,5.33c.33,1.79.43,3.63.64,5.46a2.94,2.94,0,0,0,.55.3C82.06,29.45,84,32,84,36.8c0,3.46-.09,6.93,0,10.38.19,5.44-3.75,9.28-9.31,9.23H70.9a28.36,28.36,0,0,1-1,3.8,37.55,37.55,0,0,1-2.7,5.47,5.89,5.89,0,0,0-1,3.55c.07,1.25,0,2.51,0,3.84,3.61,1.56,7.09,3.06,10.58,4.55C81,79.42,85.24,81.18,89.45,83c3.93,1.71,5.7,4.61,5.5,8.86A2.94,2.94,0,0,1,91.78,95c-.43,0-.85,0-1.27,0h-86c-.49,0-1,0-1.48,0a2.91,2.91,0,0,1-3-3.11C-.21,87.71,1.55,84.73,5.47,83c7.11-3.09,14.25-6.1,21.38-9.15C27.43,73.64,28,73.38,28.76,73ZM64.15,60a3,3,0,0,0-.69.11c-4.13,3-8.87,2.93-13.63,2.72a2.71,2.71,0,0,1-2.75-2.67,2.79,2.79,0,0,1,2.85-2.8,6.74,6.74,0,0,1,1.27,0,15.08,15.08,0,0,0,12-3.73,4,4,0,0,1,.89-.58,2.6,2.6,0,0,0,1.45-2.74c-.07-5.5-.14-11,0-16.52A20.15,20.15,0,0,0,63,24c-1.41-2.84-3.49-3.62-6.51-2.65-1.61.52-3.21,1.09-4.78,1.71a11.21,11.21,0,0,1-8.46,0,55.71,55.71,0,0,0-5.41-1.86c-2.54-.71-4.17,0-5.6,2.19a14.36,14.36,0,0,0-1.09,2.05,19.58,19.58,0,0,0-1.67,8.22c.13,7.06,0,14.12.18,21.18A14.46,14.46,0,0,0,34.27,65c5.17,5,11.38,6.25,18.23,4.64C57.84,68.43,61.62,65.16,64.15,60ZM23.78,27.46l.49.2c.21-.39.47-.77.64-1.18.72-1.76,1.28-3.6,2.15-5.28,2.55-4.9,6.68-6.74,12-5.37a48.67,48.67,0,0,1,5.6,1.92,7.43,7.43,0,0,0,5.76-.06,41.08,41.08,0,0,1,6-2,9.33,9.33,0,0,1,9.29,2.72c2.05,2.07,3.07,4.69,4.05,7.35.24.67.21,1.55,1.06,1.91.15-.16.31-.26.31-.34-.09-1.26-.15-2.54-.33-3.79-1.3-9.24-6-15-15.44-17A38.4,38.4,0,0,0,41.88,6.1c-4.47.63-8.66,2-12,5.22C25.21,15.74,24.15,21.47,23.78,27.46ZM34.21,72.24c.18,2.41.19,4.6.55,6.74a12.8,12.8,0,0,0,2.36,5.81c2.81,3.66,6.73,4.71,11.06,4.58a12,12,0,0,0,7.34-2.31c3.83-3,6-9.49,4.81-14.58C51.71,77,43.1,77,34.21,72.24ZM5.8,89.31H33.59A21,21,0,0,1,29.1,79.24a2.65,2.65,0,0,0-.56.06Q18.1,83.68,7.69,88.09A15,15,0,0,0,5.8,89.31Zm83,.1c-1.32-1.35-18.62-9-23-10.19a21,21,0,0,1-4.49,10.19ZM71.33,33.27c-.51,2.47-.4,15.88.14,17.43,1.37,0,2.78.09,4.17,0a2.59,2.59,0,0,0,2.74-2.86q.11-5.8,0-11.63a2.59,2.59,0,0,0-2.7-2.89C74.22,33.17,72.75,33.27,71.33,33.27ZM23.81,50.7V33.28c-1.58,0-3.06-.1-4.51,0a2.6,2.6,0,0,0-2.72,2.89c-.06,3.87-.06,7.75,0,11.62a2.61,2.61,0,0,0,2.74,2.87C20.71,50.78,22.13,50.7,23.81,50.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "-308.42 43.12 787.44 -591.52 787.44 -574.21 -308.42 60.42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtendenteIco);
export default __webpack_public_path__ + "static/media/atendente_ico.db61ee734098684bf4e159a5e9d623d5.svg";
export { ForwardRef as ReactComponent };